import React from "react";

export default function SideBarNav() {
  return (
    <div>
      <div class="l-sidebar">
        <div class="l-sidebar__content">
          <nav class="c-menu js-menu" id="mynavi">
            <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="my_account.html">
                    <i class="flaticon-four-grid-layout-design-interface-symbol"></i>
                  </a>
                  <ul class="crm_hover_menu">
                    <li>
                      <a href="my_account.html">
                        <i class="fa fa-circle"></i> my account
                      </a>
                    </li>
                    <li>
                      <a href="view_profile.html">
                        <i class="fa fa-circle"></i> my profile
                      </a>
                    </li>
                    {/* <li>
                      <a href="email_notification.html">
                        <i class="fa fa-circle"></i>email notification
                      </a>
                    </li> */}
                    <li>
                      <a href="/change_password">
                        <i class="fa fa-circle"></i>change password
                      </a>
                    </li>
                    <li>
                      <a href="/change_pin">
                        <i class="fa fa-circle"></i>change pin
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="c-menu__item is-active has-sub crm_navi_icon_cont">
                <a href="/my_account">
                  <div class="c-menu-item__title">
                    <span>my account</span>
                    {/* <i class="no_badge">5</i> */}
                  </div>
                </a>
                <ul>
                  <li>
                    <a href="my_account">
                      <i class="fa fa-circle"></i> my account
                    </a>
                  </li>
                  <li>
                    <a href="/profile">
                      <i class="fa fa-circle"></i> my profile
                    </a>
                  </li>
                  {/* <li>
                    <a href="email_notification.html">
                      <i class="fa fa-circle"></i>email notification
                    </a>
                  </li> */}
                  <li>
                    <a href="/change_password">
                      <i class="fa fa-circle"></i>change password
                    </a>
                  </li>
                  <li>
                    <a href="/change_pin">
                      <i class="fa fa-circle"></i>change pin
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="/deposit">
                    <i class="flaticon-movie-tickets"></i>
                  </a>
                  <ul class="crm_hover_menu">
                    <li>
                      <a href="make_deposit.html">
                        {" "}
                        <i class="fa fa-circle"></i>make deposit
                      </a>
                    </li>
                    <li>
                      <a href="deposit_list.html">
                        {" "}
                        <i class="fa fa-circle"></i> deposit lists
                      </a>
                    </li>
                    <li>
                      <a href="/payment_request">
                        {" "}
                        <i class="fa fa-circle"></i> payment request
                      </a>
                    </li>
                    <li>
                      <a href="exchange_money.html">
                        {" "}
                        <i class="fa fa-circle"></i>exchange money
                      </a>
                    </li>
                    <li>
                      <a href="/transfer_fund">
                        {" "}
                        <i class="fa fa-circle"></i>fund transfer
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="c-menu__item is-active has-sub crm_navi_icon_cont">
                <a href="/deposit">
                  <div class="c-menu-item__title">
                    <span>finance</span>
                    {/* <i class="no_badge">5</i> */}
                  </div>
                </a>
                <ul>
                  <li>
                    <a href="/deposit">
                      {" "}
                      <i class="fa fa-circle"></i>make deposit
                    </a>
                  </li>
                  <li>
                    <a href="/deposit_list">
                      {" "}
                      <i class="fa fa-circle"></i> deposit lists
                    </a>
                  </li>
                  <li>
                    <a href="/payment_request">
                      {" "}
                      <i class="fa fa-circle"></i> payment request
                    </a>
                  </li>
                  <li>
                    <a href="exchange_money.html">
                      {" "}
                      <i class="fa fa-circle"></i>exchange money
                    </a>
                  </li>
                  <li>
                    <a href="/transfer_fund">
                      {" "}
                      <i class="fa fa-circle"></i>fund transfer
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            {/* <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="transfer_fund.html">
                    <i class="flaticon-progress-report"></i>
                  </a>
                </div>
              </li>
              <li class="c-menu__item crm_navi_icon_cont">
                <a href="transfer_fund.html">
                  <div class="c-menu-item__title">fund transfer</div>
                </a>
              </li>
            </ul> */}
            <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="all_transactions.html">
                    <i class="flaticon-help"></i>
                  </a>
                  <ul class="crm_hover_menu">
                    <li>
                      <a href="all_transactions.html">
                        <i class="fa fa-circle"></i> all transactions
                      </a>
                    </li>
                    <li>
                      <a href="deposit_history.html">
                        <i class="fa fa-circle"></i>deposit history
                      </a>
                    </li>
                    {/* <li>
                      <a href="pending_history.html">
                        <i class="fa fa-circle"></i>pending history
                      </a>
                    </li> */}
                    <li>
                      <a href="exchange_history.html">
                        <i class="fa fa-circle"></i>exchange history
                      </a>
                    </li>
                    <li>
                      <a href="earnings_history.html">
                        <i class="fa fa-circle"></i>earning history
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="c-menu__item is-active has-sub crm_navi_icon_cont">
                <a href="all_transactions.html">
                  <div class="c-menu-item__title">
                    <span>reports</span>
                    {/* <i class="no_badge purple">5</i> */}
                  </div>
                </a>
                <ul>
                  <li>
                    <a href="/fund_transfer_history">
                      {" "}
                      <i class="fa fa-circle"></i>fund transfer history
                    </a>
                  </li>
                  <li>
                    <a href="/deposit">
                      <i class="fa fa-circle"></i>deposit history
                    </a>
                  </li>
                  {/* <li>
                    <a href="pending_history.html">
                      <i class="fa fa-circle"></i>pending history
                    </a>
                  </li> */}
                  <li>
                    <a href="exchange_history.html">
                      <i class="fa fa-circle"></i>exchange history
                    </a>
                  </li>
                  <li>
                    <a href="earnings_history.html">
                      <i class="fa fa-circle"></i>earning history
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            {/* <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="tickets.html">
                    <i class="flaticon-file"></i>
                  </a>
                </div>
              </li>
              <li class="c-menu__item crm_navi_icon_cont">
                <a href="tickets.html">
                  <div class="c-menu-item__title">view tickets</div>
                </a>
              </li>
            </ul> */}
            <ul class="u-list crm_drop_second_ul">
              <li class="crm_navi_icon">
                <div class="c-menu__item__inner">
                  <a href="referrals.html">
                    <i class="flaticon-settings"></i>
                  </a>
                  <ul class="crm_hover_menu">
                    <li>
                      <a href="/referrals">
                        <i class="fa fa-circle"></i> my referrals{" "}
                      </a>
                    </li>
                    {/* <li>
                      <a href="banners.html">
                        {" "}
                        <i class="fa fa-circle"></i>promotionals banners
                      </a>
                    </li> */}
                    <li>
                      <a href="/referral_list">
                        {" "}
                        <i class="fa fa-circle"></i>referral list
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="c-menu__item is-active has-sub crm_navi_icon_cont">
                <a href="#">
                  <div class="c-menu-item__title">
                    <span>referrals</span>
                    {/* <i class="no_badge purple">2</i> */}
                  </div>
                </a>
                <ul>
                  <li>
                    <a href="/referrals">
                      <i class="fa fa-circle"></i> my referrals{" "}
                    </a>
                  </li>
                  {/* <li>
                    <a href="banners.html">
                      {" "}
                      <i class="fa fa-circle"></i>promotionals banners
                    </a>
                  </li> */}
                  <li>
                    <a href="/referral_list">
                      {" "}
                      <i class="fa fa-circle"></i>referral list
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}
